import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import { useDispatch } from 'react-redux';
import _ from 'lodash';

import { createChart, rememberBoard } from '../../../events';

import styles from './styles.module.css';
import noCardIcon from './noCardIcon.png';

// localization
const messages = defineMessages({
  NO_CARDS: {
    id: 'NO_CARDS',
    defaultMessage: 'No cards on this board',
  },
  ADD_A_CARD_TO_START: {
    id: 'ADD_A_CARD_TO_START',
    defaultMessage: 'Add a card to start filling out your board.',
  },
  ADD_A_CARD: {
    id: 'ADD_A_CARD',
    defaultMessage: 'ADD A CARD',
  },
  NEW_CHART: {
    id: 'NEW_CHART',
    defaultMessage: 'New Chart',
  },
});

function NoChart({ board, intl }) {
  const dispatch = useDispatch();

  const create = () => {
    // eslint-disable-next-line no-undef
    dispatch(rememberBoard(_.cloneDeep(board)));
    dispatch(createChart(null, null, null, null, intl, messages));
  };

  return (
    <div style={{ display: 'flex' }}>
      <div className={styles.noChartsContainer}>
        <div>
          <span className={styles.noChartIcon}>
            <img src={noCardIcon} alt="logo" />
          </span>
          <p className={styles.noChartMessage}>
            <FormattedMessage {...messages.NO_CARDS} />
          </p>
          <p className={styles.noChartSubMessage}>
            <FormattedMessage {...messages.ADD_A_CARD_TO_START} />
          </p>
          <Button variant="contained" color="primary" className={styles.primaryBtn} onClick={create}>
            <FormattedMessage {...messages.ADD_A_CARD} />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(NoChart);
